import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";

import {LeadModal} from "../../application/components/LeadModal";
import {ForYouBanner} from "../../for_you/components/for_you_banner/ForYouBanner";
import {ForYouModal} from "../../for_you/components/ForYouModal";
import {OfferType} from "../../offer/types/OfferType";
import {HomepageBlogSection} from "../components/HomepageBlogSection";
import {HomepageFeaturesSection} from "../components/HomepageFeaturesSection";
import {HomepageHeader} from "../components/HomepageHeader";
import {HomepageMarketplacePromoSection} from "../components/HomepageMarketplacePromoSection";
import {HomepagePropertyGroupSection} from "../components/HomepagePropertyGroupSection";
import {HomepageRecommendedOffers} from "../components/HomepageRecommendedOffers";
import {HomepageWhyWeSection} from "../components/HomepageWhyWeSection";
import {SchemaHomepage} from "../components/SchemaHomepage";

export const HomepageView = () => {
    return (
        <div>
            <HomepageHeader />
            <Container as="section" className={forYouBannerSectionStyle}>
                <ul className={forYouBannerListStyle}>
                    <ForYouBanner selectedRegion={[]} offerTypes={[OfferType.FLAT, OfferType.HOUSE]} />
                </ul>
            </Container>
            <HomepageRecommendedOffers />
            <HomepageFeaturesSection />
            <HomepageBlogSection />
            <HomepageMarketplacePromoSection />
            <HomepageWhyWeSection />
            <HomepagePropertyGroupSection />
            <ForYouModal />
            <LeadModal />
            <SchemaHomepage />
        </div>
    );
};

const forYouBannerSectionStyle = css({
    marginTop: 4
});

const forYouBannerListStyle = css({
    margin: 0,
    padding: 0,
    listStyle: "none"
});
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";

import {LeadModal} from "../../application/components/LeadModal";
import {ForYouBanner} from "../../for_you/components/for_you_banner/ForYouBanner";
import {ForYouModal} from "../../for_you/components/ForYouModal";
import {OfferType} from "../../offer/types/OfferType";
import {HomepageBlogSection} from "../components/HomepageBlogSection";
import {HomepageFeaturesSection} from "../components/HomepageFeaturesSection";
import {HomepageHeader} from "../components/HomepageHeader";
import {HomepageMarketplacePromoSection} from "../components/HomepageMarketplacePromoSection";
import {HomepagePropertyGroupSection} from "../components/HomepagePropertyGroupSection";
import {HomepageRecommendedOffers} from "../components/HomepageRecommendedOffers";
import {HomepageWhyWeSection} from "../components/HomepageWhyWeSection";
import {SchemaHomepage} from "../components/SchemaHomepage";

export const HomepageView = () => {
    return (
        <div>
            <HomepageHeader />
            <Container as="section" className={forYouBannerSectionStyle}>
                <ul className={forYouBannerListStyle}>
                    <ForYouBanner selectedRegion={[]} offerTypes={[OfferType.FLAT, OfferType.HOUSE]} />
                </ul>
            </Container>
            <HomepageRecommendedOffers />
            <HomepageFeaturesSection />
            <HomepageBlogSection />
            <HomepageMarketplacePromoSection />
            <HomepageWhyWeSection />
            <HomepagePropertyGroupSection />
            <ForYouModal />
            <LeadModal />
            <SchemaHomepage />
        </div>
    );
};

const forYouBannerSectionStyle = css({
    marginTop: 4
});

const forYouBannerListStyle = css({
    margin: 0,
    padding: 0,
    listStyle: "none"
});
